export default "__VITE_ASSET__CNFCWXhu__"